module.exports = __webpack_public_path__ + "static/img/kim-carpenter-307030-unsplash.5d46c06.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard/kim-carpenter-307030-unsplash.svg
// module id = fho7
// module chunks = 37